import $paths from "@/constants/route-paths";

import { appConfig } from "@/config";

// Application layouts
const { layouts } = appConfig;

/** Routes meta  */
const meta = { layout: layouts.app, requiresAuth: true };

/**
 * Account routes
 */
const accountRoutes = [
  {
    path: $paths.createAccount,
    name: "add-account",
    meta,
    component: () => import("@/components/forms/AddAccountForm.vue"),
  },
  {
    path: $paths.editAccount,
    name: "edit-account",
    meta,
    component: () => import("@/components/forms/AddAccountForm.vue"),
  },
  {
    path: $paths.accounts,
    name: "accounts",
    meta,
    component: () => import("@/views/Accounts/Accounts.vue"),
  },
  {
    path: $paths.account,
    name: "account",
    meta,
    component: () => import("@/views/Accounts/Account/Account.vue"),
  },
];

export default Object.freeze(accountRoutes);
